export const createFilterTemplateFixedFromAppliedCacheKey =
  "postUsersMeOrganisationsCurrentFilterSetsV2-fixed-cache-key";
export const updateFilterTemplateFixedCacheKey =
  "patchUsersMeOrganisationsCurrentFilterSetsByFilterSetIdV2-fixed-cache-key";
